export default "__VITE_ASSET__BdSdCBOh__"